<template>
  <div class="info-page">
    <crumbs title="活动信息管理" />
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      label-position="right"
      label-width="auto"
    >
      <div class="info-page__item">
        <div class="info-page__title">
          <span>活动详细信息</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="类型" prop="actType">
              <enumerate
                url="/api/news/acttypeenum"
                v-model="form.actType"
                placeholder="请选择活动类型"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="活动标题" prop="title">
              <el-input
                v-model="form.title"
                placeholder="请输入活动标题"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="图片" prop="imgUploadList">
              <image-upload
                url="/api/achievement/uploadachiattach"
                accept="image/jpeg,image/png,image/bmp,image/webp"
                :file-list.sync="form.imgUploadList"
                :num-limit="1"
                :size-limit="10"
                :multiple="false"
              >
                <template>
                  <el-alert
                    :title="`上传图片格式要求 jpg、jpeg、webp、bmp、png；图片建议比例为16：9；每个大小不超过10MB；图片名(包含后缀名)的最大长度为100个字符。`"
                    type="warning"
                  >
                  </el-alert>
                </template>
              </image-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="时间" prop="publishDate">
              <el-date-picker
                v-model="form.publishDate"
                type="datetimerange"
                :unlink-panels="true"
                start-placeholder="开始时间"
                range-separator="至"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="组织形式" prop="actForm">
              <enumerate-radio
                v-model="form.actForm"
                url="/api/news/actformenum"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 如果是线下 选择地址 -->
        <template v-if="form.actForm === 2 || form.actForm === 3">
          <el-row :gutter="10">
            <el-col :span="24">
              <!-- prop="actAddress" -->
              <el-form-item label="活动地点">
                <div>
                  <bm-location
                    @confirm="getAddress"
                    :position="{
                      lng: form.longitude,
                      lat: form.latitude
                    }"
                  />
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="详细地址" prop="actAddress">
                <el-input
                  v-model="form.actAddress"
                  placeholder="请选择详细地址"
                  clearable
                ></el-input> </el-form-item
            ></el-col>
            <el-col :span="6">
              <el-form-item label="经度">
                <el-input :value="form.longitude" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="纬度">
                <el-input
                  :value="form.latitude"
                  disabled
                ></el-input> </el-form-item
            ></el-col>
          </el-row>
        </template>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="主办单位" prop="actCompany">
              <el-input
                v-model="form.actCompany"
                placeholder="请输入主办单位"
                maxlength="50"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          :gutter="10"
          v-for="(item, index) in form.helpOrgnaizer"
          :key="'helpOrgnaizer' + index"
        >
          <el-col :span="8">
            <el-form-item
              :label="index === 0 ? '协办单位' : ''"
              :prop="`helpOrgnaizer[${index}]`"
            >
              <el-input
                v-model="form.helpOrgnaizer[index]"
                placeholder="请输入协办单位"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <template v-if="index === form.helpOrgnaizer.length - 1">
              <el-button
                plain
                type="primary"
                icon="el-icon-plus"
                circle
                :disabled="helpOrgnaizerHasEmpty"
                @click.prevent="addCompany('helpOrgnaizer')"
              ></el-button>
            </template>
            <template v-else>
              <el-button
                plain
                type="warning"
                icon="el-icon-minus"
                circle
                @click.prevent="removeCompany('helpOrgnaizer', index)"
              ></el-button>
            </template>
          </el-col>
        </el-row>
        <el-row
          :gutter="10"
          v-for="(item, index) in form.orgnaizer"
          :key="'orgnaizer' + index"
        >
          <el-col :span="8">
            <el-form-item
              :label="index === 0 ? '承办单位' : ''"
              :prop="`orgnaizer[${index}]`"
            >
              <el-input
                v-model="form.orgnaizer[index]"
                placeholder="请输入承办单位"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <template v-if="index === form.orgnaizer.length - 1">
              <el-button
                plain
                type="primary"
                icon="el-icon-plus"
                circle
                :disabled="orgnaizerHasEmpty"
                @click.prevent="addCompany('orgnaizer')"
              ></el-button>
            </template>
            <template v-else>
              <el-button
                plain
                type="warning"
                icon="el-icon-minus"
                circle
                @click.prevent="removeCompany('orgnaizer', index)"
              ></el-button>
            </template>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="推荐活动" prop="isFirstPageRecommend">
              <el-radio-group v-model="form.isFirstPageRecommend">
                <el-radio :label="false">不推荐</el-radio>
                <el-radio :label="true">推荐</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="活动详情内容" prop="actContent">
              <editor
                v-model="form.actContent"
                imgUploadUrl="/api/achievement/uploadachiattach"
              ></editor>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="封面推荐" prop="isRecommend">
              <el-switch v-model="form.isRecommend"></el-switch>
            </el-form-item>
          </el-col>
        </el-row> -->
      </div>
    </el-form>

    <div class="submit fn-text-center mt-20">
      <template v-if="isAdd">
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerAddData('ruleForm')"
          >提交</el-button
        >
      </template>
      <template v-else>
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerModifyData('ruleForm')"
          >提交</el-button
        >
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "activityInfo",
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      // 是否处于loading状态
      isLoading: false,
      //是添加数据还是修改数据
      isAdd: true,
      //表单
      form: {
        actType: "",
        title: "",
        imgUploadList: [], // imgURL 相对应
        publishDate: [],
        actForm: 1,
        actCompany: "",
        helpOrgnaizer: [""],
        orgnaizer: [""],
        isFirstPageRecommend: false,
        actContent: "",
        isRecommend: false,
        actAddress: "",
        longitude: "",
        latitude: ""
      },
      rules: {
        actType: [isEmpty("请选择活动类型", "change")],
        title: [isEmpty("请输入活动标题")],
        actAddress: [isEmpty("请选择详细地址")],
        imgUploadList: [isEmpty("请上传图片", "change")],
        publishDate: [isEmpty("请选择时间", "change")],
        actForm: [isEmpty("请选择组织形式")],
        actCompany: [isEmpty("请输入主办单位")],
        isFirstPageRecommend: [isEmpty("请选择是否推荐", "change")],
        actContent: [isEmpty("请编辑活动详情内容")],
        isRecommend: [isEmpty("请选择封面推荐与否", "change")]
      }
    };
  },
  computed: {
    // helpOrgnaizer 是否有空项目
    helpOrgnaizerHasEmpty() {
      return this.form.helpOrgnaizer.some((item) => {
        return item.trim() === "";
      });
    },
    // orgnaizer 是否有空项目
    orgnaizerHasEmpty() {
      return this.form.orgnaizer.some((item) => {
        return item.trim() === "";
      });
    }
  },
  created() {
    const { method } = this.$route.params;
    // 默认值 走添加流程
    let isAdd = true;
    if (method === "modification") {
      //获取信息
      this.loadInfo();
      //走修改流程
      isAdd = false;
    }
    this.isAdd = isAdd;
  },
  methods: {
    // 添加删除
    addCompany(field) {
      // if (this.form[field].length > 4) return;
      this.form[field].push("");
    },
    removeCompany(field, index) {
      this.form[field].splice(index, 1);
    },
    getAddress(e) {
      const { lng, lat, addr } = e;
      this.form.longitude = lng;
      this.form.latitude = lat;
      this.form.actAddress = addr;
    },
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      const {
        // list
        publishDate,
        imgUploadList,
        ...others
      } = this.form;
      const mixin = {
        helpOrgnaizer: [],
        orgnaizer: []
      };
      Object.keys(mixin).map((item) => {
        mixin[item] = this.form[item].filter((item) => {
          return item !== "";
        });
      });
      // 处理时间
      const [startTime = "", endTime = ""] = publishDate || [];
      // 处理上传文件
      const deconstruct = (file = {}) => {
        return file.response ? file.response.dataList[0].url : file.url || "";
      };
      const imgURL = deconstruct(imgUploadList[0]);
      return {
        ...others,
        ...mixin,
        imgURL,
        startTime,
        endTime
      };
    },
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      const { startTime = "", endTime = "", imgURL, ...others } = data;
      const mixin = {
        helpOrgnaizer: [],
        orgnaizer: []
      };
      Object.keys(mixin).map((item) => {
        mixin[item] = data[item].length === 0 ? [""] : data[item];
      });
      // 处理文件
      const turnFile = {
        imgUploadList: imgURL
      };
      Object.keys(turnFile).map((key) => {
        const file = this.turnNulltoString(turnFile[key]);
        turnFile[key] =
          file === ""
            ? []
            : [
                {
                  url: file
                }
              ];
      });
      return {
        ...others,
        ...mixin,
        ...turnFile,
        publishDate: [startTime, endTime]
      };
    },
    // 点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAddData();
        }
      });
    },
    // 点击修改数据按钮
    handlerModifyData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadModifyData();
        }
      });
    },
    // 加载添加数据接口
    loadAddData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("activity", "addMessage", params).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载修改数据接口
    loadModifyData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      const { id } = this.$route.query;
      this.$api("activity", "addMessage", {
        ...params,
        id
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载数据接口
    loadInfo() {
      const { id } = this.$route.query;
      this.$api("activity", "getMessageInfo", { id }).then((res) => {
        const { code, message } = res;
        if (code === 0) {
          this.form = this.downloadProcessData(res.dataList[0]);
        } else {
          this.$message.error(message);
          this.redirectTo();
        }
      });
    },
    // 返回列表页
    redirectTo() {
      // this.redirectByPath(`/admin/activityManage/activityMessageList`);
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="less" scoped></style>
